<template>
  <div class="c-key-metrics">
    <b-table striped hover dark head-variant="dark" small :fields="fields" :items="items" :aria-label="i18n('label')">
      <template v-slot:head(title)="data">
        {{ i18n(data.label) }}
      </template>
      <template v-slot:cell(title)="data">
        <span v-if="data.item.title !== 'maxProfitPrice'">{{ i18n(data.item.title) }}</span>
        <span v-else>{{ `${i18n(data.item.title)} (${currencyData.symbol})` }}</span>
      </template>

      <template v-slot:cell(value)="data">
        <v-fidlet v-if="data.item.value !== '-'" :data="data.item.value || ''" type="float.price" />
        <span v-else> {{ data.item.value }} </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { isBuy, isStock } from '@/utils/optionChainServices/legService';
import { StrategyService } from '@/utils/optionChainServices/strategyService';

import { KeyMetrics } from '@/utils/optionChainServices/calculationService';

export default {
  name: 'c-key-metrics',
  props: {
    legs: {
      type: Object,
      required: true
    },
    underlyingData: {
      type: Object,
      required: true
    },
    interestRateData: {
      type: Object,
      required: true
    },
    currencyData: {
      type: Object,
      required: true
    },
    netDebit: {}
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'label'
        },
        {
          key: 'value',
          label: ''
        }
      ],
      items: [
        {
          title: 'maxProfit',
          value: '-'
        },
        {
          title: 'maxLoss',
          value: '-'
        },
        {
          title: 'breakEvenLow',
          value: '-'
        },
        {
          title: 'breakEvenHigh',
          value: '-'
        },
        {
          title: 'maxProfitPrice',
          value: '-'
        }
      ]
    };
  },
  watch: {
    legs: {
      handler: 'handleLegs',
      deep: true
    },
    netDebit: {
      handler: 'handleNetDebit'
    }
  },
  methods: {
    i18n(key) {
      return this.$t(`white-label.widgets.optionChain.keyMetrics.${key}`);
    },
    handleNetDebit() {
      this.handleLegs();
    },
    handleLegs() {
      if (this.legs.first || this.legs.second) {
        const keyMetrics = this.getKeyMetrics();
        this.updateItemsFromKeyMetrics(keyMetrics);
      } else {
        this.resetKeyMetrics();
      }
    },
    getKeyMetrics() {
      const netDebit = !this.netDebit
        ? this.calcNetDebitFromLegs(this.legs, this.underlyingData)
        : parseFloat(this.netDebit);
      const r = this.interestRateData['q.PRIMACT_1'] / 100;
      const r_d = this.underlyingData['q._YIELD'] / 100;

      const keyMetrics = KeyMetrics.calculateKeyMetrics(
        StrategyService.detectOptionStrategy(this.legs.first, this.legs.second),
        netDebit,
        this.legs.first,
        this.legs.second,
        r,
        r_d
      );

      return [
        keyMetrics.maxProfit,
        keyMetrics.maxLoss,
        keyMetrics.breakEvenLow,
        keyMetrics.breakEvenHigh,
        keyMetrics.maxProfitPrice
      ];
    },
    calcNetDebitFromLegs: function(legs, underlyingData) {
      let netdebit = 0;

      Object.keys(this.legs).forEach(leg => {
        const _leg = this.legs[leg];

        if (_leg) {
          if (isStock(_leg)) {
            netdebit +=
              (isBuy(_leg) ? parseFloat(underlyingData['q._ASK']) : -parseFloat(underlyingData['q._BID'])) * 1;
          } else {
            netdebit +=
              (isBuy(_leg) ? parseFloat(_leg.option['q._ASK']) : -parseFloat(_leg.option['q._BID'])) * _leg.quantity;
          }
        }
      });

      return netdebit;
    },
    updateItemsFromKeyMetrics(keyMetrics) {
      this.items.forEach((item, index) => {
        item.value = this.getFormattedKeyMetric(keyMetrics[index]);
      });
    },
    resetKeyMetrics() {
      this.updateItemsFromKeyMetrics(['-', '-', '-', '-', '-']);
    },
    // Helpers
    getFormattedKeyMetric(value) {
      value = parseFloat(value);
      if (isFinite(value)) {
        return value; //this.$f(value, 'float.price');
      } else if (value === Infinity) {
        return '∞';
      } else if (isNaN(value)) {
        return '-';
      } else if (value === null) {
        return '-';
      } else {
        return value;
      }
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-key-metrics';
</style>
